export const CREATE_GRAY_JOB_RECEIVE = 'CREATE_GRAY_JOB_RECEIVE';
export const GET_GRAY_JOB_RECEIVES = 'GET_GRAY_JOB_RECEIVES';
export const GRAY_JOB_RECEIVE_REQUEST = 'GRAY_JOB_RECEIVE_REQUEST';
export const UPDATE_GRAY_JOB_RECEIVE = 'UPDATE_GRAY_JOB_RECEIVE';
export const DELETE_GRAY_JOB_RECEIVE = 'DELETE_GRAY_JOB_RECEIVE';
export const GRAY_JOB_RECEIVE_REQUEST_FAILURE = 'GRAY_JOB_RECEIVE_REQUEST_FAILURE';